import { Component, Input, ElementRef, OnInit } from '@angular/core'
import {Project} from './project'
import {DomSanitizer} from '@angular/platform-browser'

@Component({
  selector: 'app-project',
  templateUrl: './project.component.html',
  styleUrls: ['./project.component.scss']
})
export class ProjectComponent implements OnInit {

  constructor(public el: ElementRef, private _sanitizer: DomSanitizer) { }

  private _project: any

  @Input()
  set project(project: Project) {
    this._project = project
  }
  get project(): Project { return this._project }

  ngOnInit() {
    console.log(this._project)
  }
}



// WEBPACK FOOTER //
// ./src/app/work/project.component.ts